<template>
  <el-dialog
    @close="handleClose"
    @open="handleOpen"
    :visible.sync="dialogVisible"
    :title="type === 1 ? '更新委托书' : '更换管理员'"
    width="790px"
  >
    <template v-if="currentSetp === 1">
      <el-form :model="formData" :rules="rules" ref="formRef" class="form-box" label-width="160px">
        <el-form-item label="管理员是否法人本人：">
          <template v-if="type === 1">
            <span class="manager-flag">{{ formData.legalSelf ? '是' : '否' }}</span>
          </template>
          <template v-else>
            <el-radio-group @change="handleLegalSelfChange" v-model="formData.legalSelf">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </template>
        </el-form-item>
        <el-form-item
          :class="{
            'hidden-red': disableInput
          }"
          prop="adminName"
          label="管理员姓名："
        >
          <template v-if="disableInput">
            <span>{{ formData.adminName }}</span>
            <span v-if="type === 1" @click="changeManager" style="margin-left: 10px" class="link-btn">更换管理员</span>
          </template>
          <template v-else>
            <el-input
              v-model="formData.adminName"
              :maxlength="20"
              clearable
              placeholder="请输入"
              style="width: 284px"
            ></el-input>
          </template>
        </el-form-item>
        <el-form-item
          :class="{
            'hidden-red': disableInput
          }"
          prop="idCard"
          label="管理员身份证号："
        >
          <template v-if="disableInput">
            <span>{{ formData.idCard }}</span>
          </template>
          <template v-else>
            <el-input
              v-model="formData.idCard"
              :maxlength="20"
              clearable
              placeholder="请输入"
              style="width: 284px"
            ></el-input>
          </template>
        </el-form-item>
        <!-- 管理员是法人本人的时候不展示委托书 -->
        <template v-if="type === 1 || !formData.legalSelf">
          <el-form-item prop="powerAttorneyUrl" label="企业委托书：">
            <div class="entrust-container">
              <div class="img-wrap">
                <el-upload
                  :show-file-list="false"
                  :disabled="uploadDisabled"
                  :on-error="handleError"
                  :on-progress="handleProgress"
                  :action="uploadAction"
                  :on-success="handleUploadSuccess"
                  :before-upload="beforeUpload"
                  class="upload-entrust-box"
                >
                  <div class="upload-entrust">
                    <i class="upload-icon"></i>
                    <span class="upload-text">重新上传</span>
                  </div>
                </el-upload>
                <el-image
                  :preview-src-list="[joinUrl(formData.powerAttorneyUrl)]"
                  v-if="formData.powerAttorneyUrl"
                  :src="joinUrl(formData.powerAttorneyUrl)"
                  alt=""
                />
              </div>
              <span @click="downloadTemplate" style="margin-left: 10px" class="link-btn">下载委托书模板</span>
            </div>
            <div class="entrust-tip-container">
              <p>1.下载模板，按要求填写并加盖公章，拍照上传</p>
              <p>2.委托书中的被委托人，必须跟管理员是同一人。</p>
            </div>
          </el-form-item>
        </template>
      </el-form>
    </template>
    <template v-else-if="currentSetp === 2">
      <div class="qrcode-wrap">
        <div class="qrcode-title">实名认证（人脸识别）</div>
        <div class="qrcode-tip">管理员本人，打开微信扫二维码，按步骤完成认证</div>
        <div class="qrcode-box" :class="{ 'is-expired': qrcodeCertifyResult == 3 }">
          <img :src="qrcodeUrl" alt="" />
          <div v-if="qrcodeCertifyResult == 3" @click="handleRefreshQrcode" class="expired-mask">
            二维码已过期，点击刷新
          </div>
        </div>
      </div>
    </template>
    <template v-else-if="currentSetp === 3">
      <div class="success-page" :class="{ 'is-success': qrcodeCertifyResult == 1 }">
        <div class="success-icon"></div>
        <div class="success-title">
          {{ qrcodeCertifyResult == 1 ? '已通过实名认证' : '实名认证失败' }}
        </div>
        <div class="success-tip">
          {{
            qrcodeCertifyResult == 1
              ? '已完成人脸识别，点击提交审核完成变更操作'
              : '请管理员本人再次认证，打开微信扫二维码，按步骤完成认证'
          }}
        </div>
        <el-button v-if="qrcodeCertifyResult == 1" type="primary" @click="handleSubmitChangeManager"
          >提交审核</el-button
        >
        <el-button v-else type="primary" @click="handleRetry">重新认证</el-button>
      </div>
    </template>
    <template slot="footer">
      <div>
        <template v-if="type === 1">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" :disabled="submitDisabled" @click="handleSubmit">提交审核</el-button>
        </template>
        <template v-else>
          <template v-if="currentSetp === 1">
            <el-button @click="dialogVisible = false">取消</el-button>
            <el-button type="primary" :disabled="submitDisabled" @click="goToStep2">下一步</el-button>
          </template>
          <template v-else-if="currentSetp === 2">
            <el-button @click="goToStep1">上一步</el-button>
            <el-button type="primary" :disabled="true">提交审核</el-button>
          </template>
        </template>
      </div>
    </template>
  </el-dialog>
</template>
<script>
import axiosNew from '@/api/axiosNew';
import newApi from '@/api/settings.new.api';
import apiBase from '@/api/base.new.api';
import { Loading } from 'element-ui';
import { getFileUrlPrefix } from '@/utils';
import { isIdCard } from '@fe/validator';
import { WUYI, vali } from '@/api/common';
export default {
  props: {
    visible: {
      type: Boolean
    },
    type: {
      type: Number,
      default: 1 // 1 更换委托书 2 更换管理员
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      }
    },
    disableInput() {
      // 管理员是法人的时候自动带出信息，不能编辑
      // 仅更换委托书的时候也不让编辑管理员信息
      return this.formData.legalSelf || this.type === 1;
    },
    submitDisabled() {
      // 用JSON序列化对比可能会存在key顺序不确定的问题
      const keys1 = Object.keys(this.formData);
      return keys1.every(key => this.formData[key] === this.tempData[key]);
    }
  },
  data() {
    return {
      managerInfo: {},
      uploadAction: apiBase.newUploadImg,
      uploadDisabled: false,
      loading: null,
      formData: {
        id: 0,
        legalSelf: false,
        adminName: '',
        idCard: '',
        powerAttorneyUrl: ''
      },
      tempData: {},
      currentSetp: 1,
      rules: {
        adminName: { required: true, message: '请输入管理员名称', trigger: 'blur' },
        idCard: [
          { required: true, message: '请输入身份证号码', trigger: 'blur' },
          {
            validator(rule, value, callback) {
              if (isIdCard(value)) {
                callback();
              } else {
                callback('身份证格式错误');
              }
            },
            trigger: 'blur'
          }
        ],
        powerAttorneyUrl: { required: true, message: '请上传企业委托书' }
      },
      urlPrefix: '',
      qrcodeUrl: '',
      certifyId: '',
      checker: null,
      // 认证结果 0: 未操作 1: 认证成功 2: 认证失败 3: 二维码过期,
      qrcodeCertifyResult: 0
    };
  },
  methods: {
    // 提交变更委托书
    handleSubmit() {
      axiosNew
        .post(newApi.submitPowerAttorney, {
          ...this.formData
        })
        .then(res => {
          if (res.code === 0) {
            this.$message.success('操作成功!');
            this.dialogVisible = false;
            this.$emit('changeEntrustSuccess');
          }
        });
    },
    fetchManagerInfo() {
      axiosNew.post(newApi.qryManagerinfo).then(res => {
        this.managerInfo = res.data;
        this.formData.legalSelf = res.data.cropState;
        this.formData.adminName = res.data.managerName;
        this.formData.idCard = res.data.identityCard;
        this.formData.powerAttorneyUrl = res.data.engagementLetterUrl;
        this.formData.id = res.data.id;
        this.tempData = JSON.parse(JSON.stringify(this.formData));
        if (!this.formData.id && this.formData.legalSelf) {
          this.handleLegalSelfChange(true);
        }
      });
    },
    downloadTemplate() {
      axiosNew.post(newApi.proxyStatementUrl).then(res => {
        window.open(this.urlPrefix + res.data.downloadUrl);
      });
    },
    handleClose() {
      this.currentSetp = 1;
      this.formData = {
        id: 0,
        legalSelf: false,
        adminName: '',
        idCard: '',
        powerAttorneyUrl: ''
      };
      this.tempData = JSON.parse(JSON.stringify(this.formData));
      this.qrcodeUrl = '';
      this.certifyId = '';
      this.qrcodeCertifyResult = 0;
      clearTimeout(this.checker);
    },
    handleOpen() {
      this.fetchManagerInfo();
    },
    handleError(err, file, fileList) {
      this.loading.close();
      this.uploadDisabled = false;
      this.$message.error('上传失败!');
    },
    handleProgress(event, file, fileList) {
      this.uploadDisabled = true;
    },
    handleUploadSuccess(res, file) {
      this.uploadDisabled = false;
      this.loading.close();
      if (res.code != 0) {
        return;
      }
      this.formData.powerAttorneyUrl = res.data.fileUri;
    },
    beforeUpload(file) {
      const isJPEG = file.type === 'image/jpeg';
      const isJPG = file.type === 'image/jpg';
      const isPNG = file.type === 'image/png';
      const isSize = file.size / 1024 / 1024 < vali.imgLimit;
      if (!isJPEG && !isJPG && !isPNG) {
        this.$message.error('请上传PNG、JPG、JPEG等图片格式!');
        return false;
      }
      if (!isSize) {
        this.$message.error(`上传图片大小不能超过 ${vali.imgLimit}MB!`);
        return false;
      }
      this.loading = Loading.service({
        fullscreen: true,
        text: '上传中...'
      });
    },
    handleLegalSelfChange(val) {
      if (val) {
        // 自动带出法人信息，且不可修改
        axiosNew.post(newApi.getCompanyHolderData).then(res => {
          if (res.code === 0) {
            this.formData.adminName = res.data.userName;
            this.formData.idCard = res.data.idCard;
          }
        });
      } else {
        this.formData.adminName = '';
        this.formData.idCard = '';
      }
      this.$nextTick().then(() => {
        this.$refs.formRef.clearValidate();
      });
    },
    goToStep2() {
      this.$refs.formRef.validate(async val => {
        if (!val) return;
        const metaInfo = getMetaInfo();
        const res = await axiosNew.post(newApi.getWeChatCertificateQr, {
          metaInfo: JSON.stringify(metaInfo),
          ...this.formData
        });
        if (res.code === 0) {
          this.isQrcodeExpired = 0;
          this.qrcodeUrl = res.data.url;
          this.certifyId = res.data.certifyId;
          this.currentSetp++;
          this.qrcodeChecker();
        }
      });
    },
    async handleRefreshQrcode() {
      const metaInfo = getMetaInfo();
      const res = await axiosNew.post(newApi.getWeChatCertificateQr, {
        metaInfo: JSON.stringify(metaInfo),
        ...this.formData
      });
      if (res.code === 0) {
        this.qrcodeUrl = res.data.url;
        this.certifyId = res.data.certifyId;
        this.isQrcodeExpired = 0;
        this.qrcodeChecker();
      }
    },
    goToStep1() {
      this.qrcodeUrl = '';
      this.certifyId = '';
      this.currentSetp = 1;
      this.isQrcodeExpired = 0;
      clearTimeout(this.checker);
    },
    joinUrl(url) {
      if (!url) return '';
      if (url.startsWith('http')) return url;
      if (url.startsWith('/')) {
        url = url.substring(1);
      }
      return this.urlPrefix + url;
    },
    changeManager() {
      this.$emit('changeManager');
    },
    // 轮询 查询二维码是否扫描成功
    qrcodeChecker() {
      const walk = async () => {
        if (this.currentSetp !== 2) return;
        const res = await axiosNew.post(
          newApi.getWeChatCertificateQrStatus,
          {
            certifyId: this.certifyId
          },
          { silence: true }
        );
        if (res.code === 0) {
          this.qrcodeCertifyResult = res.data.verifyState;
          // 成功 或者 失败的时候到下一步（状态页面）
          if ([1, 2].includes(res.data.verifyState)) {
            this.currentSetp++;
            return;
          }
          // 二维码过期的情况
          if (res.data.verifyState === 3) {
            return;
          }
        } else {
          // 接口报错的时候回到上一步
          return;
        }
        // 请求失败或者认证失败的时候 过1s再尝试
        this.checker = setTimeout(walk, 1000);
      };
      walk();
    },
    async handleSubmitChangeManager() {
      const res = await axiosNew.post(newApi.submitCompanyAdmin, {
        certifyId: this.certifyId
      });
      if (res.code === 0) {
        this.dialogVisible = false;
        this.$message.success('操作成功');
        this.$emit('changeManagerSuccess');
      }
    },
    handleRetry() {
      // 重新认证

      this.qrcodeUrl = '';
      this.certifyId = '';
      this.currentSetp = 1;
      this.isQrcodeExpired = 0;
      clearTimeout(this.checker);
    }
  },
  async created() {
    this.urlPrefix = await getFileUrlPrefix();
  }
};
</script>

<style lang="postcss" scoped>
.form-box {
  :deep(.hidden-red) {
    .el-form-item__label {
      &::before {
        display: none;
      }
    }
  }
  .manager-flag {
    color: #01d28e;
  }
  .link-btn {
    display: inline-block;
    color: #3399ff;
    cursor: pointer;
  }
  .entrust-container {
    display: flex;
    .img-wrap {
      width: 480px;
      height: 360px;
      background-color: #f6f7fb;
      position: relative;
      .el-image {
        display: block;
        width: 257px;
        height: 100%;
        margin: 0 auto;
      }
      .upload-entrust-box {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
        z-index: 1;
        .upload-entrust {
          width: 96px;
          height: 90px;
          background-color: rgba(0, 0, 0, 0.6);
          display: flex;
          align-items: center;
          flex-direction: column;
          border-radius: 8px;
          overflow: hidden;
          .upload-icon {
            width: 24px;
            height: 24px;
            background-image: url(../../../assets/img/setting/ico24px_sctp@2x.png);
            background-size: 100% 100%;
            margin-top: 20px;
          }
          .upload-text {
            color: #fff;
            text-align: center;
            font-size: 12px;
            line-height: 18px;
            margin-top: 8px;
          }
        }
      }
    }
  }
  .entrust-tip-container {
    width: 480px;
    border-radius: 8px;
    background: #fff8f2;
    height: 56px;
    padding: 8px 16px;
    box-sizing: border-box;
    line-height: 20px;
    font-size: 12px;
    color: #f90;
    margin-top: 18px;
  }
}

.qrcode-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  .qrcode-title {
    color: #333;
    font-weight: 500;
    font-size: 20px;
    line-height: 28px;
    margin-top: 60px;
    text-align: center;
  }
  .qrcode-tip {
    margin-top: 8px;
    font-size: 14px;
    color: #ff9900;
    line-height: 20px;
  }
  .qrcode-box {
    width: 200px;
    height: 200px;
    margin: 40px auto 80px;
    position: relative;
    img {
      display: block;
      width: 100%;
      height: 100%;
    }
    &.is-expired {
      .expired-mask {
        position: absolute;
        cursor: pointer;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 0.7);
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
      }
    }
  }
}

.success-page {
  display: flex;
  align-items: center;
  flex-direction: column;
  .success-icon {
    width: 44px;
    height: 44px;
    background-image: url(../../../assets/img/setting/ico_suc.png);
    background-size: 100% 100%;
    margin-top: 60px;
  }

  &:not(.is-success) {
    .success-icon {
      background-image: url(../../../assets/img/setting/ico44px_special_warning@2x.png);
    }
  }
  .success-title {
    color: #333;
    font-size: 20px;
    font-weight: 500;
    line-height: 28px;
    margin-top: 16px;
  }

  .success-tip {
    margin-top: 8px;
    font-size: 14px;
    color: #aaa;
    line-height: 20px;
  }
  .el-button {
    margin-top: 40px;
    margin-bottom: 80px;
  }
}
</style>
